module.exports = __webpack_public_path__ + "img/5.cc410ae9.jpg";